import { Component, inject, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FlowItemModel } from '../../../shared/models/FlowItemModel';
import { ScoutingFlowService } from '../../../shared/services/scouting-flow.service';
import { MatDivider, MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule, MatLabel } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { ReportTightComponent } from '../../components/report-tight/report-tight.component';
import { NoteTightComponent } from '../../components/note-tight/note-tight.component';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-scouting-flow-tight',
  imports: [MatProgressBarModule, MatListModule, MatIconModule, MatDivider, FormsModule, MatLabel, MatFormFieldModule, MatInputModule, MatButtonModule, TranslatePipe, DatePipe, ReportTightComponent, NoteTightComponent],
  templateUrl: './scouting-flow-tight.component.html',
  styleUrl: './scouting-flow-tight.component.css'
})
export class ScoutingFlowTightComponent implements OnInit {
  _flowitems: FlowItemModel[] = [];
  isLoading: boolean = false;
  isSearching: boolean = false;
    filterText = '';

    classesRankingBox: string[] = ['grayshading','redshading','yellowshading', 'greenshading', 'lightgreenshading','blueshading' ];
  classesRankingBoxCapacity: string[] = ['grayshading','redshading','yellowshading', 'yellowshading', 'yellowshading','greenshading','greenshading','greenshading' ];
  classesRankingBoxProjection: string[] = ['grayshading','redshading','yellowshading', 'yellowshading', 'greenshading','greenshading','greenshading','greenshading','greenshading' ];


  flowService = inject(ScoutingFlowService);
  
  ngOnInit() {
    this.loadDefaultFlow();
  }

  private loadDefaultFlow(): void {
    this.isLoading = true;
    this.isSearching = false;
    this.flowService.getAllReports()
      .pipe(finalize(() => {
        this.isLoading = false;
      }))
      .subscribe({
        next: r => {
          this._flowitems = r;
        },
        error: err => {
          console.error('Failed to load scouting flow items.', err);
        }
      });
  }

  onSearch(): void {
    const term = this.filterText?.trim() ?? '';
    if (term === '') {
      this.loadDefaultFlow();
      return;
    }
    this.isLoading = true;
    this.isSearching = true;
    this.flowService.searchFlow(term)
      .pipe(finalize(() => {
        this.isLoading = false;
        this.isSearching = false;
      }))
      .subscribe({
        next: r => {
          this._flowitems = r;
        },
        error: err => {
          console.error('Failed to search scouting flow items.', err);
        }
      });
  }

  onClearSearch(): void {
    this.filterText = '';
    this.loadDefaultFlow();
  }

  trackFlowItem(item: FlowItemModel, index: number): string {
    const zeroGuid = '00000000-0000-0000-0000-000000000000';
    if (item.ReportId && item.ReportId !== zeroGuid) {
      return item.ReportId;
    }
    if (item.PlayerNoteId && item.PlayerNoteId !== zeroGuid) {
      return item.PlayerNoteId;
    }
    if (item.GameId) {
      return item.GameId;
    }

    return index.toString();
  }
}
